module.exports = __webpack_public_path__ + "img/1.ce8c4a56.jpg";